import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
// import React from "react";
import { Formik, Field, Form } from "formik";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    ModalHeading,
    ModalSubHeading,
    CalendarIcon,
    RupeeIcon
} from "../../Styles/InputStyle2";
import { Select, MenuItem } from "@mui/material";
// import DropzoneImageUpload from "../Properties/DropzoneImageUpload";
import { FaUserPlus } from "react-icons/fa";
import { toast } from "react-toastify";


const EditAssignmentDetails = ({ setEditAssignmentDetails, addAssetFunctionMutate, isaddAssetLoading, stepOneData, setViewDetail

}) => {

    const initialValues = {
        assignedProperty: "Property 2",
        assignTo: "2",
        currentStatus: "",
        quantity: "",

    };
    const assignedPropertyList = {
        "Property 1": ["Room 1", "Room 2", "Room 3"],
        "Property 2": ["Room 4", "Room 5", "Room 6"],
        "Property 3": ["Room 7", "Room 8", "Room 9"],
        "Property 4": ["Room 10", "Room 11", "Room 12"],
        "Property 5": ["Room 13", "Room 14", "Room 15"],
        "Property 6": ["Room 16", "Room 17", "Room 18"],
        "Property 7": ["Room 19", "Room 20", "Room 21"],
    };

    const handleBack = () => {
        setEditAssignmentDetails(false);
        setViewDetail(true);

    }


    const handleSubmit = (values) => {
        const payload = {
            assignedProperty: values.assignedProperty,
            assignTo: values.assignTo,
            currentStatus: values.currentStatus,
            quantity: Number(values.quantity),
        };
        // setSelectedForm("4");
        console.log("payload data of assignment details", payload);
        setEditAssignmentDetails(false);
        setViewDetail(true);
    };
    const handleCross = () => {
        setEditAssignmentDetails(false);
        setViewDetail(true);
    }


    return (
        <Container>
            <Header>
                <Title>{"Edit Assignment Details"}</Title>
                <CloseButton onClick={handleCross}>
                    <MdClose size={24} />
                </CloseButton>
            </Header>
            <Content>
                <Formik initialValues={stepOneData || initialValues} onSubmit={handleSubmit}>
                    {({ values, setFieldValue }) => (
                        <Form className="px-2">
                            {/* <ModalSubHeading>Step 3</ModalSubHeading> */}
                            {/* <ModalHeading>Assignment/Location Details</ModalHeading> */}
                            <ScrollableContent>
                                <Wrapper>
                                    <InputGroup>
                                        <Label>Select Property  </Label>
                                        <Select
                                            value={values.assignedProperty}
                                            onChange={(e) => {
                                                setFieldValue("assignedProperty", e.target.value);
                                                setFieldValue("assignedRoom", "");
                                            }}
                                            displayEmpty
                                            fullWidth
                                            className="px-2"

                                        >
                                            <MenuItem value="" disabled>
                                                Select Property
                                            </MenuItem>
                                            {Object.keys(assignedPropertyList).map((type) => (
                                                <MenuItem key={type} value={type}>
                                                    {type}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </InputGroup>

                                    {/* {values.assignedProperty && (
                                                <InputGroup>
                                                    <Label>Select Room *</Label>
                                                    <Select
                                                        value={values.assignedRoom}
                                                        onChange={(e) => setFieldValue("assignedRoom", e.target.value)}
                                                        displayEmpty
                                                        fullWidth
                                                        className="px-2"
                                                         
                                                    >
                                                        <MenuItem value="" disabled>
                                                            Select Room
                                                        </MenuItem>
                                                        {assignedPropertyList[values.assignedProperty].map((option) => (
                                                            <MenuItem key={option} value={option}>
                                                                {option}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </InputGroup>
                                            )} */}
                                    <InputGroup>
                                        <Label htmlFor="assignTo">Assign To </Label>
                                        {/* <FieldWrappers> */}
                                        <Select
                                            name="assignTo"
                                            id="assignTo"
                                            value={values.assignTo}
                                            onChange={(e) => setFieldValue("assignTo", e.target.value)}

                                            className="w-full pl-2"
                                            style={{ height: "40px" }}

                                        >
                                            <MenuItem value="1">Tenant</MenuItem>
                                            <MenuItem value="2">Maintenance Staff</MenuItem>
                                            <MenuItem value="3">Unassigned</MenuItem>
                                        </Select>
                                        {/* </FieldWrappers> */}
                                    </InputGroup>
                                    <InputGroup>
                                        <Label htmlFor="quantity">Total Count *</Label>
                                        <FieldWrappers>
                                            <Field
                                                type="text"
                                                id="quantity"
                                                name="quantity"
                                                value={values.quantity}
                                                autoComplete="off"

                                                onKeyPress={(e) => {
                                                    if (!/[0-9]/.test(e.key)) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                maxLength={3}
                                            />
                                        </FieldWrappers>
                                    </InputGroup>
                                    <InputGroup>
                                        <Label htmlFor="currentStatus">Current Status </Label>
                                        {/* <FieldWrappers> */}
                                        <Select
                                            name="currentStatus"
                                            id="currentStatus"
                                            value={values.currentStatus}
                                            onChange={(e) => setFieldValue("currentStatus", e.target.value)}
                                            className="w-full pl-2"
                                            style={{ height: "40px" }}
                                        >
                                            <MenuItem value="1">Active</MenuItem>
                                            <MenuItem value="2">In Maintenance</MenuItem>
                                            <MenuItem value="3">Disposed</MenuItem>
                                            <MenuItem value="3">In Use</MenuItem>

                                        </Select>
                                        {/* </FieldWrappers> */}
                                    </InputGroup>
                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <SideCancelBtn type="button" onClick={handleBack}>
                                    Cancel
                                </SideCancelBtn>
                                <SubmitBtn type="submit">
                                    Submit
                                </SubmitBtn>
                            </ActionSection>
                        </Form>
                    )}
                </Formik>
            </Content>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const Title = tw.h1`text-white text-lg md:text-xl font-medium`;
const CloseButton = tw.button`text-white`;
const Content = tw.div`px-4 h-full flex flex-col justify-between pb-4 relative`;

export default EditAssignmentDetails;